import React from 'react'
import SideMenuMonitoring, {menuItemsMonitoring} from '../../components/SideMenuMonitoring/SideMenuMonitoring'


import { useState } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import '../DocumentationTeamHealth/DocTeamHealth.css'

const DataSecurity = () => {
    const [inactive, setInactive] = useState(false);

    return (
      <>
      			
<div style={{marginTop : "30px"}} >
           <SideMenuMonitoring
            onCollapse={(inactive) => {
             // console.log(inactive);
              setInactive(inactive);
            }}
          />

          <div className={`container ${inactive ? "inactive" : ""}`}>

            {/* improvememt, not recorded in video, its just looping through menuItemsMonitoring
            instead of hard coding all the routes */}
            {menuItemsMonitoring.map((menu, index) => (
              <>
                <Route key={menu.name} exact={menu.exact} path={menu.to}>
               

                  <p>Application monitoring</p>                     
                <h3>Data Security and Privacy Statement</h3>

                <p> This privacy policy describes how we treat your personal information and data when you use a Agil4You  Atlassian addon, hereafter referred to as "the addon". </p>             
                <p>Please note, you are also responsible for periodically reviewing this End user License Agreement, as it may be updated from time to time. You understand and accept that further use of a Agil4You Atlassian addon, should this End user License Agreement be updated, is subject to your acceptance of the revised Agreement.</p>
              
                <h3>What information do we collect?</h3>
                <p>We do not not collect anny informations about you</p>

                <h3>Do we disclose any information to outside parties?</h3>
                <p> We do not sell, trade, or otherwise transfer to outside parties your personally identifiable information.  </p>
                <p> Your Consent </p>
                <p>  By using our site, you consent to our privacy policy. </p>

                <h3>Changes to our Privacy Policy</h3>
                <p>If we decide to change our privacy policy, we will post those changes on this page, and/or update the Privacy Policy modification date.</p>

                 {/*  
                  <button style={{
                    backgroundColor: "green",
                    border: "none",
                    color: "white",
                    padding: "15px 32px",
                    textAlign: "center",
                    textDecoration: "none",
                    display: "inline-block",
                    fontSize: "16px",
                    margin: "4px 2px",
                    cursor: "pointer",
                    borderRadius: "10px",
                  }}>Next</button>
                 */}

                 
                 
  
  
                </Route>
                {menu.subMenus && menu.subMenus.length > 0
                  ? menu.subMenus.map((subMenu, i) => (
                      <Route key={subMenu.name} path={subMenu.to}>
                        <h1>{subMenu.name}</h1>
                      </Route>
                    ))
                  : null}
              </>
            ))}
             
  
            {/* <Switch>
              <Route exact path={"/"}>
                <Dashboard />
              </Route>
              <Route exact path={"/content"}>
                <Content />
              </Route>
              <Route path={"/content/courses"}>
                <Courses />
              </Route>
              <Route path={"/content/videos"}>
                <Videos />
              </Route>
              <Route path={"/design"}>
                <Design />
              </Route>
              <Route exact path={"/content-2"}>
                <Content2 />
              </Route>
              <Route path={"/content-2/courses"}>
                <Courses2 />
              </Route>
              <Route path={"/content-2/videos"}>
                <Videos2 />
              </Route>
              <Route path={"/design-2"}>
                <Design2 />
              </Route>
            </Switch> */}
           
          </div>
</div>
      </>
      
    )
  }

export default DataSecurity
